import { GrupoProdutoCulturaCentroCusto } from "./GrupoProdutoCulturaCentroCusto";
import { MBase } from "./MBase";
import * as moment from 'moment';

export class GrupoProduto extends MBase {
    Descricao:string = "";
    EmpresaId: number;
    IdERP:string = "";
    Ativo:boolean = true;
    UsuarioAlteracaoDesc: string;
    //Auxiliar para custo
    CustoPrevisto: number = 0;
    CustoRealizado: number = 0;
    CustoPrevistoHa: number = 0;
    CustoRealizadoHa: number = 0;
    Servico:boolean = false;
    //Integração ERP
    CentroCustoERP:string = "";
    listaGrupoProdutoCulturaCentroCusto: GrupoProdutoCulturaCentroCusto[];
    listaGruposCusto: GrupoProdutoCulturaCentroCusto[];
    get descAtivo(): string{
      return this.Ativo ? 'Ativo' : 'Inativo'
    }

    get dataAlteracaoStr(): string{
      return moment(this.DataAlteracao).format('DD/MM/YYYY HH:mm')
    }

}
